import { bool, func, oneOfType, string } from 'prop-types'

import noop from 'shared/utils/noop'
import OffCanvasBottomLinks from 'views/components/organisms/OffCanvas/OffCanvasBottomLinks'
import OffCanvasItemList from 'views/components/organisms/OffCanvas/OffCanvasItemList'
import OffCanvasTopLinks from 'views/components/organisms/OffCanvas/OffCanvasTopLinks'
import { offCanvasCategory, shopLanguagesType } from 'views/utils/propTypes'

const OffCanvasBody = ({
  data,
  language,
  goNextHandler,
  // availableLanguages
  userLoggedIn,
  subscriptionService,
}) => (
  <div className="o-OffCanvasView__body">
    {data.topCategories && (
      <OffCanvasTopLinks
        userLoggedIn={userLoggedIn}
        subscriptionService={subscriptionService}
        goNextHandler={goNextHandler}
        data={data.topCategories}
        ghosts
      />
    )}

    <OffCanvasItemList
      // TODO: take care of this on some level before here and pass adequate data
      data={data.categories || data}
      goNextHandler={goNextHandler}
      showCategoryTitle={!data.categories}
    />

    {data.bottomCategories && (
      <OffCanvasBottomLinks
        data={data.bottomCategories}
        goNextHandler={goNextHandler}
        language={language}
        // availableLanguages={availableLanguages}
      />
    )}
  </div>
)
OffCanvasBody.propTypes = {
  goNextHandler: func,
  data: offCanvasCategory.isRequired,
  language: oneOfType([string, shopLanguagesType]),
  userLoggedIn: bool,
  subscriptionService: bool,
}

OffCanvasBody.defaultProps = {
  language: null,
  goNextHandler: () => noop,
  userLoggedIn: false,
  subscriptionService: false,
}

export default OffCanvasBody
